import LogoSVG from '@/assets/logo.svg'
import {type SVGProps} from 'react'

interface LogoProps extends SVGProps<SVGSVGElement> {
  className?: string
}

export const Logo = ({className = '', ...props}: LogoProps) => {
  return <LogoSVG className={className} {...props} />
}
